module.exports = __webpack_public_path__ + "media/couple-testimonial-01.05ef9b2e.png";